<template>
  <section id="info" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">租金</div>
      </a-space>
    </div>

    <a-descriptions bordered :column="1" class="fixed-13-desc">
      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">出租参考价</span>
        </template>
        <span class="price-value">{{ floorPriceText }}</span>
        <span> </span>
        <span class="price-unit">{{ floorPriceUnitText }}</span>
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">租金支付方式</span>
        </template>
        {{
          intentLeaseInfo.rentPaymenclaim == 1
            ? `押${intentLeaseInfo.rentPaymenclaimDeposit || "--"}付${
                intentLeaseInfo.rentPaymenclaimPay || "--"
              }`
            : intentLeaseInfo.rentPaymenclaim == 2
            ? intentLeaseInfo.rentPaymenclaimOtherDesc || "--"
            : "--"
        }}
      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {
  props: {
    intentLeaseInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    floorPriceText() {
      const type = Number(this.intentLeaseInfo.listingPriceType);

      if (type === 1) {
        return this.formatMoney(this.intentLeaseInfo.listingPrice);
      }

      if (type === 2) {
        const min = this.intentLeaseInfo.listingPriceDown;
        const max = this.intentLeaseInfo.listingPriceUp;

        if (!this.hasValue(min) && !this.hasValue(max)) {
          return "--";
        }

        if (this.hasValue(min) && this.hasValue(max)) {
          return `${this.formatMoney(min)} - ${this.formatMoney(max)}`;
        }

        if (this.hasValue(min)) {
          return `${this.formatMoney(min)} 起`;
        }

        return `${this.formatMoney(max)} 以内`;
      }

      return this.formatMoney(this.intentLeaseInfo.intentLeaseInfo);
    },

    floorPriceUnitText() {
      const map = {
        1: "元/月",
        2: "元/年",
        3: "元/天/平方米",
        4: "元/月/平方米",
      };

      return map[this.intentLeaseInfo.listingPriceUnit] || "元/年";
    },
  },

  methods: {
    hasValue(value) {
      return value !== undefined && value !== null && value !== "";
    },

    formatMoney(value) {
      if (!this.hasValue(value)) {
        return "--";
      }

      const num = Number(value);

      if (Number.isNaN(num)) {
        return value;
      }

      return num.toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}

.fixed-13-desc /deep/ .ant-descriptions-item-label {
  width: 25%;
}

.fixed-13-desc /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}
</style>